export const reportingQueryKeys = {
  all: ["gge-reporting"] as const,
  modelSoftware: () => [...reportingQueryKeys.all, "model-software"] as const,
  modelSoftwareDetails: (softwareName?: string) => [...reportingQueryKeys.all, "model-software-details", softwareName] as const,
};
